<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/work-order.svg" />
          </div>
          <div>
            <div class="card_title_1">WORK ORDER MONITORING</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="card-body">
      <!-- <h5>ALL REGION</h5> -->
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6 mbl-gen">
              <ol
                class="breadcrumb"
                style="
                  text-transform: capitalize;
                  justify-content: start;
                  font-weight: bold;
                "
              >
                <li
                  v-for="(bc, idx) in breadcrumbs"
                  :key="bc.id"
                  :class="[
                    'breadcrumb-item',
                    idx === breadcrumbs.length - 1
                      ? 'active'
                      : 'breadcrumb-items',
                  ]"
                  :style="
                    idx === breadcrumbs.length - 1
                      ? 'font-weight:bold;cursor:default;'
                      : 'color:#999999; text-decoration: underline; cursor: pointer;'
                  "
                  @click="
                    idx !== breadcrumbs.length - 1 && breadCrumbClick(idx)
                  "
                >
                  {{ bc.label }}
                </li>
              </ol>
            </div>
            <div
              style="text-align: right; color: #7a7a7a; font-size: small"
              class="col-6 mbl-gen"
            >
              Periode:
              {{ period }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="table-responsive"
        style="border: 1px solid #e5e7ed; border-radius: 8px; margin-top: -27px"
      >
        <table class="table">
          <thead style="--bs-table-bg: #f3f3f3">
            <tr>
              <th
                @click="sort('name')"
                scope="col"
                style="
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16.41px;
                  letter-spacing: 0.02em;
                  align-content: center;
                "
              >
                {{
                  activeUid
                    ? "Induk"
                    : activeUp3
                    ? "Area"
                    : activeUlp
                    ? ulp === "BATAM"
                      ? "Area"
                      : "ULP"
                    : "Regions"
                }}<i v-if="!isRegion" class="m-l-5 fa fa-arrow-up"></i
                ><i v-if="isRegion" class="m-l-5 fa fa-arrow-down"></i>
              </th>
              <th width="100px"></th>
              <th
                @click="sort('pendingOverSla')"
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                  text-wrap: nowrap;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: black; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>
                  Belum Tindak Lanjut Over SLA
                  <i v-if="isPendingOver" class="fa fa-arrow-up"></i
                  ><i v-if="!isPendingOver" class="fa fa-arrow-down"></i>
                </div>
              </th>
              <th
                @click="sort('ongoingOverSla')"
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                  text-wrap: nowrap;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #ff5151; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>
                  Sedang Tindak Lanjut Over SLA
                  <i v-if="isNotPendingOver" class="fa fa-arrow-up"></i
                  ><i v-if="!isNotPendingOver" class="fa fa-arrow-down"></i>
                </div>
              </th>
              <th
                @click="sort('pending')"
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                  text-wrap: nowrap;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #ffc772; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>
                  Belum Tindak Lanjut
                  <i v-if="isPending" class="fa fa-arrow-up"></i
                  ><i v-if="!isPending" class="fa fa-arrow-down"></i>
                </div>
              </th>
              <th
                @click="sort('ongoing')"
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                  text-wrap: nowrap;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #52cf8b; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>
                  Sedang Tindak Lanjut
                  <i v-if="isOngoing" class="fa fa-arrow-up"></i
                  ><i v-if="!isOngoing" class="fa fa-arrow-down"></i>
                </div>
              </th>
              <th
                @click="sort('completed')"
                scope="col"
                style="
                  font-size: 10px;
                  font-weight: 400;
                  line-height: 9.38px;
                  letter-spacing: 0.02em;
                  text-align: -webkit-center;
                  text-wrap: nowrap;
                "
              >
                <div
                  class="m-b-5"
                  style="
                    width: 10px; /* Adjust size of the dot */
                    height: 10px; /* Same as width to ensure a perfect circle */
                    background-color: #00a3e9; /* Replace with your desired color */
                    border-radius: 50%; /* Makes the div circular */
                  "
                ></div>
                <div>WO</div>
                <div>
                  Selesai <i v-if="isCompleted" class="fa fa-arrow-up"></i
                  ><i v-if="!isCompleted" class="fa fa-arrow-down"></i>
                </div>
              </th>
            </tr>
          </thead>
          <tbody
            style="
              font-size: 14px;
              letter-spacing: 0.02em;
              text-align: center;
              color: #4e4e4e;
            "
          >
            <tr class="hover" v-for="(item, id) in workOrder" :key="id">
              <th
                scope="row"
                v-if="item.name.includes('UID') || item.name.includes('UIW')"
                style="text-align: start"
              >
                <span
                  class="mbl-gen"
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >General Manager</span
                >
                {{ item.name }}
              </th>
              <th
                scope="row"
                v-if="item.name.includes('UP3')"
                style="text-align: start"
              >
                <span
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >Manager</span
                >
                {{ item.name }}
              </th>
              <th
                v-if="
                  !item.name.includes('UP3') &&
                  !item.name.includes('UID') &&
                  !item.name.includes('UIW')
                "
                scope="row"
                style="text-align: start"
                :style="item.id === 'total' ? ' font-weight:bold;' : ''"
              >
                {{ item.name }}
              </th>
              <td>
                <span
                  @click="detail(item)"
                  v-if="item.hasDetail && item.id !== 'total'"
                  class="detail"
                  >DETAILS
                  <i style="color: #00a3e9" class="fa fa-angle-right"></i
                ></span>
              </td>
              <td :style="item.id === 'total' ? 'font-weight:bold' : ''">
                {{ formattedNumber(item.pendingOverSla) }}
              </td>
              <td :style="item.id === 'total' ? 'font-weight:bold' : ''">
                {{ formattedNumber(item.ongoingOverSla) }}
              </td>
              <td :style="item.id === 'total' ? 'font-weight:bold' : ''">
                {{ formattedNumber(item.pending) }}
              </td>
              <td :style="item.id === 'total' ? 'font-weight:bold' : ''">
                {{ formattedNumber(item.ongoing) }}
              </td>
              <td :style="item.id === 'total' ? 'font-weight:bold' : ''">
                {{ formattedNumber(item.completed) }}
              </td>
            </tr>
            <tr class="hover" v-for="(item, id) in dataTotal" :key="id">
              <th
                scope="row"
                v-if="item.name.includes('UID') || item.name.includes('UIW')"
                style="text-align: start"
              >
                <span
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >General Manager</span
                >
                {{ item.name }}
              </th>
              <th
                scope="row"
                v-if="item.name.includes('UP3')"
                style="text-align: start"
              >
                <span
                  style="
                    background-color: #00a3e9;
                    padding: 1%;
                    color: white;
                    border-radius: 5px;
                  "
                  >Manager</span
                >
                {{ item.name }}
              </th>
              <th
                v-if="!item.name.includes('UP3') && !item.name.includes('UID')"
                scope="row"
                style="text-align: start"
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                {{ item.name }}
              </th>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                <span
                  @click="detail(item)"
                  v-if="item.hasDetail && item.id !== 'total'"
                  class="detail"
                  >DETAILS <i class="fa fa-angle-right"></i
                ></span>
              </td>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                {{ formattedNumber(item.pendingOverSla) }}
              </td>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                {{ formattedNumber(item.ongoingOverSla) }}
              </td>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                {{ formattedNumber(item.pending) }}
              </td>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF; font-weight:bold'
                    : ''
                "
              >
                {{ formattedNumber(item.ongoing) }}
              </td>
              <td
                :style="
                  item.id === 'total'
                    ? 'background-color:#EFF7FF;font-weight:bold'
                    : ''
                "
              >
                {{ formattedNumber(item.completed) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
const apiDistribution = DistributionService.build();
import { formattedNumber } from "@/utils/helper";

export default {
  props: [],
  components: {
    IconSvg,
  },
  data() {
    return {
      isRegion: false,
      isPendingOver: false,
      isNotPendingOver: false,
      isPending: false,
      isOngoing: false,
      isCompleted: false,
      sortKey: "name", // Default sort key
      sortAsc: true, // Default sort direction
      last_update: "",
      activeUid: false,
      activeUp3: false,
      activeUlp: false,
      uid: "",
      up3: "",
      ulp: "",
      idUId: "",
      idUp3: "",
      idUlp: "",
      breadcrumbs: [{ label: "ALL REGION", id: "" }],
      workOrder: [],
      dataTotal: [],
      period: "",
      temp1: "",
      temp2: "",
      temp3: "",
      temp4: "",
    };
  },
  mounted() {
    this.getDataDistributionWorkOrder("");
  },
  computed: {
    filteredData() {
      // Filter out items with the specific ID
      return this.workOrder.filter((item) => item.id !== "total");
    },
    workOrder() {
      return this.filteredData.slice().sort((a, b) => {
        if (a[this.sortKey] < b[this.sortKey]) return this.sortAsc ? -1 : 1;
        if (a[this.sortKey] > b[this.sortKey]) return this.sortAsc ? 1 : -1;
        return 0;
      });
    },
  },
  methods: {
    convertToDDMMMYYYY(date, month, year) {
      if (month !== null) {
        return moment(`${date}, ${month}, ${year}`, "DD, M, YYYY").format(
          "DD MMM YYYY"
        );
      } else {
        return "-";
      }
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
      if (key === "name") {
        this.isRegion = !this.isRegion;
      } else if (key === "pendingOverSla") {
        this.isPendingOver = !this.isPendingOver;
      } else if (key === "ongoingOverSla") {
        this.isNotPendingOver = !this.isNotPendingOver;
      } else if (key === "pending") {
        this.isPending = !this.isPending;
      } else if (key === "ongoing") {
        this.isOngoing = !this.isOngoing;
      } else {
        this.isCompleted = !this.isCompleted;
      }
    },
    async getDataDistributionWorkOrder(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionWorkOrder(param);
      if (res && res.status == 200) {
        this.last_update = res.data.lastUpdate;
        this.dataTotal = res.data.data.filter((item) => item.id === "total");
        this.workOrder = res.data.data;
        this.period = this.convertToDDMMMYYYY(
          res.data.data[0].day,
          res.data.data[0].month,
          res.data.data[0].year
        );
      }
    },
    async getDataDistributionWorkOrderDetailRegionById(id) {
      let param = Object.assign({
        id: id,
      });
      const res =
        await apiDistribution.getDataDistributionWorkOrderDetailRegionById(
          param
        );
      if (res && res.status == 200) {
        this.workOrder = res.data.data;
      }
    },
    breadCrumbClick(idx) {
      // Keep breadcrumbs up to the clicked one
      this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1);
      // Fetch data for that breadcrumb
      this.getDataDistributionWorkOrder(this.breadcrumbs[idx].id);
    },
    detail(item) {
      // Add to breadcrumbs if not already present
      const exists = this.breadcrumbs.find((b) => b.id === item.id);
      if (!exists) {
        this.breadcrumbs.push({ label: item.name, id: item.id });
      }
      this.getDataDistributionWorkOrder(item.id);
    },
    formattedNumber,
  },
};
</script>
<style lang="scss">
.detail {
  display: none;
  &:hover {
    .i {
      color: #00a3e9 !important;
    }
  }
}

.hover:hover .detail {
  display: block;
  font-weight: bold;
  color: #00a3e9;
  cursor: pointer;
  background-color: #e5f7ff;
}
.detail:hover i {
  color: #00a3e9 !important;
}
.breadcrumb-items:hover {
  background-color: #00a3e9;
  color: white !important;
  border-radius: 10px;
  padding: 1%;
  text-decoration: none !important;
}
.breadcrumb-icon {
  --bs-breadcrumb-divider: ">";

  li {
    display: inline-block;
  }
}
::v-deep
  .page-wrapper
  .page-body-wrapper
  .page-title
  .breadcrumb
  .breadcrumb-item
  + .breadcrumb-item:before {
  content: ">" !important;
}
::v-deep .page-wrapper .page-body-wrapper .page-title {
  margin: 0 -27px 0px !important;
}
::v-deep .page-title {
  margin: 0 -27px 0px !important;
}
</style>
